import moment from "moment";
import React, { FC } from "react";
type ExamCardProps = {
  currTest: any;
};
const ExamCard: FC<ExamCardProps> = ({ currTest }): JSX.Element => {
  return (
    <div >
      <div className="flex flex-row items-center justify-between border-b-2 border-[#2563EB] mt-4">
        <p className="text-2xl font-semibold ">Exam information</p>
      </div>
      <div className="mt-4  grid grid-cols-12 gap-y-5">
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          Centre Name
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          Rajarhat Institute of Technology
        </div>
        {/* <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          Centre Code
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          Ab78923Jaki
        </div> */}
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          Reporting Circle
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          Kolkata
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          Exam Category
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          {currTest.category}
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          Exam Name
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          {currTest.title}
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          No. of Candidate
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          {new Intl.NumberFormat("en-IN").format(4500)}
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          Exam Date
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          {moment(new Date(currTest.exam_start_time)).format("DD-MM-YYYY")}
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          Exam Timing
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          {moment(new Date(currTest.exam_start_time)).format("LT") + " "}-{" "}
          {moment(new Date(currTest.exam_end_time)).format("LT")}
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          Total Marks
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          {currTest.total_marks}
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          No. of Question
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          {currTest.total_questions}
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          Duration
        </div>
        <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
          {currTest.duration + " min"}
        </div>
        <div className="col-span-12 grid grid-cols-12">
          <div className="lg:col-span-3 sm:col-span-6 col-span-12 text-base font-semibold">
            Instruction
          </div>
          <div className="lg:col-span-9 sm:col-span-12 col-span-12 text-base font-semibold">
            {currTest.instructions}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamCard;
